/**
 * @desc hello2
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  a: string,
  params: API.basics.baseCity.hello2.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseCity/123/${a}`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
